import {
    makeEndpoint,
    makeGetRequestSettings,
    makePutRequestSettings,
} from '../../../services/common/utils';

import UrlConst from '../../../constants/UrlConst';
import apiClient from '../../../services/common/apiClient';

import {
    IGetTicketsParams,
    IGetWorkflowsParams,
    IPutTicket,
    ITicket,
    ITicketHistory,
    IWorkflow,
} from '../types';

export const makeTicketsUrl = (suffix: string = '', params = {}) => {
    return makeEndpoint(UrlConst.TICKETS_URL, '/' + suffix, {
        ...params,
    });
};

export const restGetTickets = (
    queryParams?: IGetTicketsParams
): Promise<{
    content: ITicket[];
    pageable: { size: number; number: number; sort: unknown };
    totalSize: number;
}> => apiClient.send(makeGetRequestSettings(makeTicketsUrl('', queryParams)));

export const restGetTicket = (id: string): Promise<ITicket> =>
    apiClient.send(makeGetRequestSettings(makeTicketsUrl(`/${id}`)));

export const restGetTicketHistory = (id: string): Promise<ITicketHistory[]> =>
    apiClient.send(makeGetRequestSettings(makeTicketsUrl(`/${id}/changes`)));

export const restPutTicket = (ticket: IPutTicket, id: string): Promise<null> =>
    apiClient.send(makePutRequestSettings(makeTicketsUrl(`/${id}`), ticket));

export const restGetWorkflows = (
    queryParams?: IGetWorkflowsParams
): Promise<IWorkflow[]> =>
    apiClient.send(
        makeGetRequestSettings(makeTicketsUrl('/workflows', queryParams))
    );

export const restGetWorkflow = (id: string): Promise<IWorkflow> =>
    apiClient.send(makeGetRequestSettings(makeTicketsUrl(`/workflows/${id}`)));
